import * as yup from 'yup'
import { IndividualFindArtFormData } from './types'

export const IndividualFindArtFormDataSchemas = [
  // step 1
  yup.object<Pick<IndividualFindArtFormData, 'roomType'>>({
    roomType: yup.string().required(),
  }),
  // step 2
  yup.object<Pick<IndividualFindArtFormData, 'artStyles'>>({
    artStyles: yup.array().of(yup.string()).required().min(1),
  }),
  // step 3
  yup.object<Pick<IndividualFindArtFormData, 'artColors'>>({
    artColors: yup.array().of(yup.string()).notRequired(),
  }),
  // step 4
  yup.object<Pick<IndividualFindArtFormData, 'size'>>({
    size: yup.array().of(
      yup.object({
        label: yup.string().required(),
        value: yup.string().required(),
        isSelected: yup.boolean().required(),
      }),
    ),
  }),

  // step 5
  yup.object<Pick<IndividualFindArtFormData, 'budget' | 'customBudget' | 'isOtherCustomBudget'>>({
    budget: yup.array().of(
      yup.object({
        label: yup.string().required(),
        min: yup.number().nullable().min(0, 'Budget Min must be a positive number'),
        max: yup.number().nullable().min(0, 'Budget Max must be a positive number'),
        isSelected: yup.boolean().required(),
      }),
    ),

    customBudget: yup
      .object()
      .nullable()
      .shape({
        min: yup
          .number()
          .nullable()
          .transform((_, originalValue) => (originalValue === '' ? null : Number(originalValue)))
          .typeError('Custom budget min must be a number')
          .min(0, 'Budget Min must be a positive number')
          .max(1000000, 'Budget Min must be less than 1,000,000')
          .when('isOtherCustomBudget', {
            is: true,
            then: (schema) =>
              schema.test('budgetMin-dependent', (budgetMin, { createError, parent }) => {
                const budgetMax = parent.budgetMax

                // check if it's both null
                if (!budgetMin && !budgetMax) {
                  return createError({
                    path: 'customBudget.budgetMin',
                    message: 'Please provide at least min budget or max budget',
                  })
                }

                // check if max budget is less than min budget
                if (budgetMax != null && budgetMin != null && Number(budgetMax) < Number(budgetMin)) {
                  return createError({
                    path: 'customBudget.budgetMax',
                    message: 'Min budget must be less than max budget',
                  })
                }

                return true
              }),
          }),
        max: yup
          .number()
          .nullable()
          .transform((_, originalValue) => (originalValue === '' ? null : Number(originalValue)))
          .typeError('Custom budget max must be a number')
          .min(0, 'Budget Max must be a positive number')
          .max(1000000, 'Budget Max must be less than 1,000,000')
          .when('isOtherCustomBudget', {
            is: true,
            then: (schema) =>
              schema.test('budgetMax-dependent', (budgetMax, { createError, parent }) => {
                const budgetMin = parent.budgetMin

                // check if it's both null
                if (!budgetMax && !budgetMin) {
                  return createError({
                    path: 'customBudget.budgetMax',
                    message: 'Please provide at least min budget or max budget',
                  })
                }

                // check if max budget is less than min budget
                if (budgetMax != null && budgetMin != null && Number(budgetMax) < Number(budgetMin)) {
                  return createError({
                    path: 'customBudget.budgetMin',
                    message: 'Max budget must be greater than min budget',
                  })
                }

                return true
              }),
          }),
      }),
  }),
]
